import React from 'react';
import styled from 'styled-components';
import ServiceDescription from './ServiceDescription';
import AcceptableUse from './AcceptableUse';
import DataCollection from './DataCollection';
import {
  AccessibilitySection,
  ThirdPartySection,
  IntellectualPropertySection,
  PlatformAvailabilitySection,
  AIExplainabilitySection,
  TerminationSection,
  JurisdictionSection,
  UpdatesSection,
  ContactSection
} from './RemainingTermsSections';
import Navigation from '../../navigation/header';
import CTASection from '../../landing/landing_home/empower';
import Footer from '../../Footer/footer';

const TermsAndConditions = () => {
  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />
       <PageBackground>
        <Navigation/>
      <TermsCard>
        <TermsContent>
          <TermsHeaderContainer>
            <HeaderContainer>
      <Title>Terms & Conditions</Title>
    </HeaderContainer>
          </TermsHeaderContainer>
          
          <ServiceDescription />
          <AcceptableUse />
          <DataCollection />
          <AccessibilitySection />
          <ThirdPartySection />
          <IntellectualPropertySection />
          <PlatformAvailabilitySection />
          <AIExplainabilitySection />
          <TerminationSection />
          <JurisdictionSection />
          <UpdatesSection />
          <ContactSection />

        </TermsContent>
      </TermsCard>
      </PageBackground>
      
    <CTASection />
      <Footer />
  
        </>
  );
};

const PageBackground = styled.div`
  height: 100%;
  width: 100%;
  background: linear-gradient(to bottom, #5e2bff 0px, #5e2bff 500px, #F5F5F9 100px, #F5F5F9 100%);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 200px 0;

  @media (max-width: 640px) {
    padding: 40px 0;
    background: linear-gradient(to bottom, #5e2bff 0px, #5e2bff 100px, #ffffff 100px, #ffffff 100%);
  }
`;


const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
`;

const Title = styled.h1`
  color: #1c1b1f;
  letter-spacing: -0.32px;
  font: 700 32px/120% Inter, -apple-system, Roboto, Helvetica, sans-serif;
  margin: 0;
  @media (max-width: 991px) {
    font-size: 28px;
    line-height: 120%;
  }
  @media (max-width: 640px) {
    font-size: 24px;
    line-height: 120%;
  }
`;

const TermsCard = styled.main`
    display: flex;
  width: 1120px;
  padding: 56px;
  flex-direction: column;
  align-items: flex-start;
  gap: 64px;
  border-radius: 24px;
  margin: 0 auto;
  max-width: 100%;
  box-sizing: border-box;
  background-color: #fff;

  @media (max-width: 991px) {
    width: 100%;
    padding: 40px 32px;
    gap: 48px;
  }

  @media (max-width: 640px) {
    padding: 24px 16px;
    gap: 32px;
  }
`;

const TermsContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 42px;
  align-self: stretch;
  @media (max-width: 640px) {
    gap: 32px;
  }
`;

const TermsHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
`;

export default TermsAndConditions;
